module.exports = __webpack_public_path__ + "img/selected4-min.b36eb425.png";